/**
 * useAreaStore — Areas of Responsibility (PARA method).
 *
 * Storage: 'areas' (collection)
 * Methods: addArea, updateArea, deleteArea, reorderAreas
 */
import { create } from 'zustand';
import { storage, onRehydrate } from '../utils/storage';

const STORAGE_KEY = 'areas';

const useAreaStore = create((set, get) => ({
    areas: storage.get(STORAGE_KEY, []),

    _persist() {
        storage.set(STORAGE_KEY, get().areas);
    },

    addArea(area) {
        const newArea = {
            id: crypto.randomUUID(),
            name: area.name || 'Untitled Area',
            standard: area.standard || '',
            emoji: area.emoji || '📂',
            icon: area.icon || (area.emoji ? { type: 'emoji', value: area.emoji, color: null } : { type: 'emoji', value: '📂', color: null }),
            color: area.color || 'categorical-10',
            mode: area.mode || 'both',
            sortOrder: area.sortOrder ?? get().areas.length,
        };
        set(state => ({ areas: [...state.areas, newArea] }));
        get()._persist();
        return newArea;
    },

    updateArea(id, updates) {
        set(state => ({
            areas: state.areas.map(a =>
                a.id === id ? { ...a, ...updates } : a
            ),
        }));
        get()._persist();
    },

    deleteArea(id) {
        set(state => ({
            areas: state.areas.filter(a => a.id !== id),
        }));
        get()._persist();
    },

    reorderAreas(areaIds) {
        set(state => ({
            areas: state.areas.map(a => {
                const idx = areaIds.indexOf(a.id);
                return idx >= 0 ? { ...a, sortOrder: idx } : a;
            }),
        }));
        get()._persist();
    },
}));

// Re-read from localStorage after cloud sync completes
onRehydrate(() => {
    useAreaStore.setState({ areas: storage.get(STORAGE_KEY, []) });
});

export default useAreaStore;
